import { createSelector } from 'reselect';
import { reduxKey } from '../constants';
import { EditorState } from '../types';

export function getStoreSlice(state: any): EditorState['editor'] {
  if (!state[reduxKey]) {
    return {} as any;
  }
  return state[reduxKey]['editor'];
}

export const getMenuUpdate = createSelector(getStoreSlice, state => {
  return state.menuUpdates;
});

export const isMuroOpen = createSelector(getStoreSlice, state => {
  return state.muroOpen;
});

export const getMuroProps = createSelector(getStoreSlice, state => {
  return state.muroProps;
});
